import GameInstance from "../../models/GameInstance.model";

/**
 * Returns a list of available games from enum, formatted for the as Button
 * Selector item.
 * @param gameInstances
 * @param schemaEnum
 */
function getPhilippinesGames(gameInstances: GameInstance[], schemaEnum: any) {
    const filteredGames = gameInstances
        .filter(gameInstance => {
            return schemaEnum.items.enum.includes(gameInstance.game.id);
        })
        .map(gameInstance => {
            return {
                value: gameInstance.game.id,
                label: gameInstance.game.name
            };
        });
    return filteredGames;
}

export default getPhilippinesGames;
